import SubScript from 'src/component/common/Subscript/SubScript'
import {JoinWrap} from 'src/styles/views/Join'
import {useEffect} from "react"
import {useResetRecoilState} from "recoil"
import {CertNumState, TelNumState, TimeOutState, TranIdState} from "src/store/recoil/common"
import { MvnoCheckValue} from "src/store/Join"
import useWindowDimensions from "src/hooks/useGetWindowSize";

const Join = () => {
    const ResetCertNum = useResetRecoilState(CertNumState)
    const ResetTelNum = useResetRecoilState(TelNumState)
    const ResetTimeOut = useResetRecoilState(TimeOutState)
    const ResetTranId = useResetRecoilState(TranIdState)
    const ResetMvnoCheckValue = useResetRecoilState(MvnoCheckValue)

    const {width} = useWindowDimensions()

    useEffect(() => {
        return () => {
            ResetTelNum()
            ResetTimeOut()
            ResetTranId()
            ResetCertNum()
            ResetMvnoCheckValue()
        }
    }, [ResetCertNum, ResetTelNum, ResetTimeOut, ResetTranId, ResetMvnoCheckValue])

    return (
        <JoinWrap>
            <SubScript/>
            <div className="alert-wrap">
                {width > 600 ?
                <ul>
                    <li className="bold">매월 부가세포함 3,300원</li>
                    <li className="bold">휴대폰가족보호는 SKT, KT, LGU+ 통신요금에 사용한 일수만큼 매월 부과됩니다.</li>
                    <li>
                        안드로이드 7.0 이상을 지원하지 않는 단말기 및 피처폰 서비스 이용불가
                    </li>
                </ul> :
                <ul>
                    <li className="bold">매월 부가세포함 3,300원 휴대폰가족보호는</li>
                    <li className="bold">SKT, KT, LGU+ 통신요금에 사용한 일수만큼 매월 부과됩니다.</li>
                    <li>(안드로이드 7.0 이상을 지원하지 않는</li>
                    <li>단말기 및 피처폰 서비스 이용불가)</li>
                </ul>}
            </div>
        </JoinWrap>
    )
}
export default Join
